<template>
    <div>
        <app-new-breadcrumb></app-new-breadcrumb>
        <div class="main">
            <iframe title="Finansijski pregled - Neprofitne organizacije 2024"
                src="https://app.powerbi.com/view?r=eyJrIjoiMDIzMDgxMDItNjI5NC00ZTA3LTgxODUtMDAyOWNjNDYzZjcyIiwidCI6ImYyYmUzMTU2LTE1N2EtNGM0OS1hYjk4LTUwODEzYTJhMThmZSIsImMiOjl9"
                frameborder="0" allowfullscreen="true"></iframe>
        </div>
    </div>
</template>

<script>
import Breadcrumb from "../../common/Breadcrumb.vue";

export default {
    components: {
        appNewBreadcrumb: Breadcrumb,
    },
}
</script>

<style scoped>
.main {
    padding: 15px 7% 0 7%;
}

iframe {
    width: 100%;
    height: 80vh;
    border: none;
    margin-bottom: 25px;
}
</style>
